const styles = ({ COLORS, BREAKPOINTS }) => ({
  content: {
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      width: '40%'
    }
  },
  video: {
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      width: '50%'
    },
    '& img': {
      maxWidth: '100%'
    },
    '& a': {
      display: 'block',
      transition: '300ms ease-in-out'
    },
    '& a:hover': {
      opacity: 0.7
    }
  },
  intro: {
    '& h2': {
      fontSize: '32px'
    },
    fontSize: '20px',
    lineHeight: '25px',
    maxWidth: '60%',
    textAlign: 'center',
    margin: '0 auto 30px'
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '100%'
  },
  title: {
    fontSize: '32px'
  },
  listTitle: {
    fontSize: '24px',
    marginBottom: '10px'
  },
  lists: {
    marginTop: '30px',
    '& a': {
      color: COLORS.BLUE.NORMAL,
      textDecoration: 'none',
      fontWeight: 'bold'
    },
    '& li': {
      marginTop: '10px'
    }
  },
  boxes: {
    display: 'flex',
    width: '80%',
    margin: '0 auto',
    flexWrap: 'wrap',
    justifyContent: 'space-around'
  },
  box: {
    maxWidth: '44%',
    background: '#f8f8f8',
    padding: '20px',
    borderRadius: '8px',
    margin: '1% 1% 4% 1%',
    '& img': {
      maxWidth: '100%',
      background: '#fff',
      borderRadius: '8px',
      padding: '10px'
    },
    '& p': {
      fontSize: '18px',
      lineHeight: '23px',
      marginBottom: '24px',
      marginTop: '10px'
    },
    '& h3': {
      marginBottom: '0px'
    }
  }
})

export default styles
